import { connect } from 'react-redux';
import { compose, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import withFetchCampaign from '../hoc/withFetchCampaign';
import ViewCampaign from '../components/ViewCampaign';

const ViewCampaignContainer = compose(
  withRouter,
  withFetchCampaign,
  connect((state) => ({
    showPushPreview: state.engagement.campaign.sendPush || state.engagement.campaign.sendSms,
    startDate: state.engagement.campaign.recurringStartDate,
    endDate: state.engagement.campaign.recurringEndDate,
    frequency: state.engagement.campaign.recurringFrequency,
    time: state.engagement.campaign.recurringTime,
    shopId: state.auth.shop,
    isRecurring: state.engagement.campaign.type === 'recurring',
    isCampaignPaused:
      state.engagement.campaign.type === 'recurring' &&
      state.engagement.campaign.recurringNextOccurrenceDateTime === null,
  })),
  withState('isLoading', 'setIsLoading', true),
  lifecycle({
    componentDidMount() {
      this.props.fetchCampaign().then(this.props.setIsLoading(false));
    },
  })
)(ViewCampaign);

export default ViewCampaignContainer;
